import type { VehicleKind } from '../vehicle/IVehicle.js';

const STORAGE_KEY = 'roadworld.vehicleKind.v1';

/** Read the last-used vehicle from localStorage. Returns null if nothing was saved,
 *  the value is malformed, or localStorage is unavailable (e.g. privacy mode). */
export function load(): VehicleKind | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'car' || raw === 'motorcycle') return raw;
    return null;
  } catch {
    return null;
  }
}

/** Persist the player's current vehicle so it survives a page reload. Failures (quota,
 *  privacy mode) are swallowed — the feature is a nicety, not load-bearing. */
export function save(kind: VehicleKind): void {
  try {
    localStorage.setItem(STORAGE_KEY, kind);
  } catch {
    /* ignore */
  }
}
